import { createApp, markRaw } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import '@/assets/css/tailwind.css'
import '@fortawesome/fontawesome-pro/css/all.css'
import * as Sentry from '@sentry/vue'
import { createHead, VueHeadMixin } from '@unhead/vue'
import VueGtagPlugin from 'vue-gtag'
const app = createApp(App)
const pinia = createPinia()

pinia.use(({ store }) => {
  store.$router = markRaw(router)
})

Sentry.init({
  app,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  environment: import.meta.env.VITE_APP_STAGE,
  release: import.meta.env.VITE_APP_VERSION
})

const head = createHead()

app.use(pinia)
  .use(router)
  .use(head)
  .use(VueGtagPlugin, {
    appName: import.meta.env.VITE_SITE_NAME,
    pageTrackerScreenviewEnabled: true,
    config: {
      id: import.meta.env.VITE_GTAG_MEASUREMENT
    },
  },router)
  .mixin(VueHeadMixin)
  .mount('#app')
